import axios from 'axios';

// search vat input api
export async function searchVatInputAPI(Data) {
	let vatinputlist = [];
	const vatInputVal = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/vatInput/search/?vatInputName=${vatInputVal}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		vatinputlist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return vatinputlist;
}

// check existing vat input api
export async function getVatInputAPI(Data) {
	let vatinputlist = [];
	const VatName = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/vatInput/getVat/?vatName=${VatName}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		vatinputlist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return vatinputlist;
}

//create vat input api
export async function createVatInputAPI(Data, userID) {
	let VatInputData = [];
	try{
		const axiosResponse = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/vatInput/create/`,
			data: {Data, userID}
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		VatInputData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return VatInputData;
}

//update vat input api
export async function updateVatInputAPI(Data, vatID, userID) {
	let VatInputData = [];
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/vatInput/update/?vatID=${vatID}&userID=${userID}`,
			data: Data
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		VatInputData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return VatInputData;
}